// フェーズ1: 一時的に無効化 (Issue #2758)
// AWSコスト削減のための緊急対応として、このフック全体を無効化
// accountSelectorへの依存を完全に切断して過剰なAPI呼び出しを防止
//
// 問題の詳細:
// - v2.4.0でuseFirebaseUserPropertiesDataが25個のフックから呼ばれる
// - 各フックがaccountSelectorを依存関係として持つ
// - エラー時のキャッシュ無効化により185,306回/日のAPI呼び出しが発生
// - 約$50/日のAWSコスト増加
//
// 対応:
// - 早期リターンでaccountSelectorの実行を完全に回避
// - React Hooksのルールに従いHooksは一切使用しない

export type FirebaseUserProperties = {
  appVersion: string
  model: string
  platform: string
  channelType?: string | null
  optIn?: string | null
  isLogin?: string | null
  accountId?: string | null
  domain?: string | null
  isManager?: string | null
  gender?: string | null
  job?: string | null
  school?: string | null
  prefecture?: string | null
  age?: string | null
  married?: string | null
  child?: string | null
  joinedFreeOrganization?: string | null
}

export const useFirebaseUserPropertiesData = () => {
  // 無条件で空のレスポンスを返す
  return {
    data: null,
    isLoading: false,
    error: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    refetch: () => {},
  }
}
